import * as React from "react";
import Loadable from "react-loadable";
import OptionsWithoutRender = LoadableExport.OptionsWithoutRender;
import { Loader } from "../../page/loader";

interface ComponentProps {
  event: any;
}

type Props = ComponentProps;

const loadableOptions: OptionsWithoutRender<Props> = {
  loader: () => import("../../../modules/manage-marketplace").then((module) => module.MarketPlacePanel) as Promise<any>,
  loading: () => <Loader isActive={true} />,
};

export const MarketPlacePanel = Loadable(loadableOptions);

